module.exports = __webpack_public_path__ + "img/parking-icon.ee9372f7.svg";